import React from "react";
import { AuthConsumer } from "../../Context/AuthContext";
import functions from "../functions";
export const RenderSecure = (props) => {
  console.log(props.code);
  return (
    <AuthConsumer>
      {(userProps) => {
        // Check if the code is an empty string. If so, render the children without checking permissions.
        if (
          props.code === "" ||
          functions.findInObject(userProps.permissionLists, props.code)
        ) {
          return <>{props.children}</>;
        } else {
          return null;
        }
      }}
    </AuthConsumer>
  );
};
